import { render } from "./RuleItem.vue?vue&type=template&id=745e3909"
import script from "./RuleItem.vue?vue&type=script&lang=js"
export * from "./RuleItem.vue?vue&type=script&lang=js"

import "./RuleItem.vue?vue&type=style&index=0&id=745e3909&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.8.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__